import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ChirpPropShapes from 'javascripts/shared/chirp_prop_shapes';
import { bubEvents } from 'javascripts/shared/events/bub_events';

import { ChirpButton } from 'javascripts/components/chirp_button';
import { ReportAudiobookModal } from 'javascripts/components/audiobook/report_audiobook_modal';

import flagIcon from 'images/flag.svg';

export function ReportAudiobookButton({ audiobook, condensed }) {
  const [showReportAudiobookModal, setShowReportAudiobookModal] = useState(false);
  const [resetForm, setResetForm] = useState(false);

  function onCloseShowReportAudiobookModal() {
    setShowReportAudiobookModal(false);
    setResetForm(true);
  }

  function handleReportAudiobookClick() {
    bubEvents.track('Report audiobook', 'Clicked link', {
      label: 'Report this audiobook',
      properties: {
        audiobook_id: audiobook.id,
      },
    });

    setShowReportAudiobookModal(true);
  }

  function renderButton() {
    if (condensed) {
      return (
        <ChirpButton
          displayStyle='gray'
          displayStyleHover='navy'
          displayType='link'
          icon={flagIcon}
          label='Report'
          onClick={handleReportAudiobookClick}
          fontSize='small'
        />
      );
    }
    return (
      <ChirpButton
        displayType='link'
        displayStyle='underline'
        label='Report this audiobook'
        fontSize='small'
        onClick={handleReportAudiobookClick}
      />
    );
  }

  return (
    <React.Fragment>
      {renderButton()}
      <ReportAudiobookModal
        isOpen={showReportAudiobookModal}
        onRequestClose={onCloseShowReportAudiobookModal}
        audiobook={audiobook}
        resetForm={resetForm}
      />
    </React.Fragment>
  );
}

ReportAudiobookButton.propTypes = {
  audiobook: ChirpPropShapes.audiobook.isRequired,
  condensed: PropTypes.bool,
};

ReportAudiobookButton.defaultProps = {
  condensed: false,
};
